if (!customElements.get('search-suggestions')) {
  const SearchSuggestions = class extends HTMLElement {
    connectedCallback() {
      this.searchTimeoutID = -1;
      this.searchInput = this.closest('form').querySelector('input[name="q"]');
      this.searchInput.addEventListener('keyup', this.handleInputChange.bind(this));
      this.searchInput.addEventListener('change', this.handleInputChange.bind(this));
       this.searchInput.addEventListener('focus', function(evt){
        this.closest('.main-search').classList.add('has-search-result');
      });
    }

    handleInputChange() {
      const valueToSearch = this.searchInput.value;

      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        clearTimeout(this.searchTimeoutID);

        this.searchTimeoutID = setTimeout(() => {
          this.fetchSuggestions(valueToSearch);
        }, 500);
      } else if (!valueToSearch.length) {
        clearTimeout(this.searchTimeoutID);

        if (this.searchSuggestionsAbortController) {
          this.searchSuggestionsAbortController.abort();
          this.searchSuggestionsAbortController = null;
        }

        this.innerHTML = '';
      }

      this.oldSearchValue = valueToSearch;
    }

    fetchSuggestions(terms) {
      if (this.searchSuggestionsAbortController) {
        this.searchSuggestionsAbortController.abort();
      }
      this.searchSuggestionsAbortController = new AbortController();

      fetch(`${theme.routes.predictiveSearch}?q=${encodeURIComponent(terms)}&section_id=search-suggestions`, {
        signal: this.searchSuggestionsAbortController.signal
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const results = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.search-suggestions-wrapper');

          this.innerHTML = '';
          this.insertAdjacentElement('beforeend', results.firstElementChild);
          if(this.closest('.main-search').classList.contains('mobile-search-bar')){
            document.querySelector('html').style.overflow= 'hidden';
          }
        })
        .catch((error) => {
          if (error.code === 20) {
            return; // aborted
          }
          throw error;
        });
    }
  };

  window.customElements.define('search-suggestions', SearchSuggestions);

  document.addEventListener("DOMContentLoaded", function () {
    const searchContainer = document.querySelector(".main-search");
    const mobileSearchContainer = document.querySelector(".mobile-search-bar");

    document.addEventListener("click", function (event) {
      const clickedInside = searchContainer.contains(event.target);

      if (clickedInside) {
        searchContainer.classList.add("has-search-result");
      } else {
        searchContainer.classList.remove("has-search-result");
      }
      if (mobileSearchContainer.contains(event.target)) {
        mobileSearchContainer.classList.add("has-search-result");
      } else {
        document.querySelector('html').style.overflow= 'visible';
        mobileSearchContainer.classList.remove("has-search-result");
      }
    });
  });
}
